import Vue from "vue";
import store from "@/store";
import router from "@/router";
import "./assets/scss/style.scss";
import 'vue-select/dist/vue-select.css';
import App from "./App.vue";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import VueCookies from 'vue-cookies';
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import i18n from './i18n/i18n.js'
import VueFeather from "vue-feather";
import vSelect from 'vue-select'
import VueUploadComponent from 'vue-upload-component'
import InstantSearch from "vue-instantsearch";
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import {toggleBusy} from "@/util/ComponentUtils";


const requireComponent = require.context(
    "./components/base",
    false,
    /Base[A-Z]\w+\.(vue|js)$/
);
Vue.config.productionTip = false;
Vue.config.errorHandler = async (err, vm, info) => {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.
    // TODO: Perform any custom logic or log to server
    // console.log("####Global####")
    // console.log(err)
    // console.log(vm)
    // console.log(vm.$vnode.data.ref)
    // console.log(info)
    await toggleBusy(false)
};
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    const componentName = upperFirst(
        camelCase(
            fileName
                .split("/")
                .pop()
                .replace(/\.\w+$/, "")
        )
    );
    Vue.component(componentName, componentConfig.default || componentConfig);

    Vue.component('v-select', vSelect)
});
Vue.use(VueFeather);
Vue.use(IconsPlugin);
Vue.use(BootstrapVue);
Vue.use(VueCookies);
Vue.use(Splitpanes);
Vue.use(Pane);
Vue.use(Treeselect);
Vue.use(InstantSearch);
Vue.use(VueUploadComponent);
new Vue({store, router, i18n, render: (h) => h(App)}).$mount("#app");
